// extracted by mini-css-extract-plugin
export default {"primaryFontFamily":"Roboto","primaryBlack1":"#262a3d","primaryBlack2":"#333","primaryBlue":"#1d5fc3","secondaryOffWhite":"#dadde1","secondaryRed":"#dd2447","fontSize3":"14px"};